import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            主题索引 · 发现更多
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
            按分类浏览最新电影在线看、热门电视剧全集和综艺节目在线播放资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-6xl mx-auto">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#"
              className="bg-background-50 rounded-lg p-5 border border-background-200/70 group hover:border-primary-300 transition-all cursor-pointer flex items-start gap-4"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg flex-shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-950 mb-1 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-1">{item.desc}</p>
                <span className="text-xs font-medium text-primary-600">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}